module.exports = "<div\r\n  class=\"icheck-primary\"\r\n  [ngStyle]=\"position === 1 ? {} : { 'margin-left': '15px' }\"\r\n>\r\n  <input\r\n    [id]=\"fieldName\"\r\n    [disabled]=\"disabled\"\r\n    class=\"ixsControl\"\r\n    type=\"checkbox\"\r\n    [(ngModel)]=\"value\"\r\n    (blur)=\"onBlur()\"\r\n  />\r\n  <label [for]=\"fieldName\">{{ caption }}</label>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixscheckbox/ixscheckbox.component.html
// module id = 1198
// module chunks = 322